import React, { useEffect } from 'react';
import './Loader.css';
import { config } from '../config/config';

const Loader = ({ show }) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [show]);

  if (!show) return null;

  return (
    <div className="loader-overlay">
      <div className="loader-content">
        <div className="loader-spinner-circle">
          <img src={config.logoicon} alt="Loading" className="loader-image" />
          <div className="loader-spinner"></div>
        </div>
        <p className="loader-text">Please wait, loading...</p>
      </div>
    </div>
  );
};

export default Loader;